<template>
  <page>
    <page-header :title="pageTitle" :subtitle="pageSubtitle">
      <template slot="actions">
        <slot name="actions"></slot>
      </template>
    </page-header>

    <page-content>
      <rest-list
        :payload="fetchEndpoint"
        ref="list"
        @dataLoaded="$emit('dataLoaded', $event)"
        :max-height="listMaxHeight"
      >
        <slot name="table"></slot>
      </rest-list>
    </page-content>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeader'
import PageContent from '@/common/components/page/PageContent'
import RestList from '@/common/components/rest/RestList'

export default {
  name: 'RestListPage',

  components: {
    Page,
    PageHeader,
    PageContent,
    RestList
  },

  props: {
    pageTitle: {
      type: String,
      required: true
    },

    pageSubtitle: {
      type: String,
      required: false
    },

    fetchEndpoint: {
      type: Object,
      required: true
    },

    listMaxHeight: {
      type: String,
      required: false
    }
  },

  methods: {
    refresh() {
      this.$refs.list.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListPage.vue